import { type ReactNode, useEffect, useMemo } from 'react';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';

import { handleIntlError, registerIntl, unregisterIntl } from './internal/intl';

const cache = createIntlCache();

export function MessagesProvider({
  locale = 'en-US',
  messages,
  children,
}: {
  locale?: string;
  messages: Record<string, string>;
  children: ReactNode;
}) {
  const intl = useMemo(
    () => createIntl({ locale, defaultLocale: 'en-US', messages, onError: handleIntlError }, cache),
    [locale, messages],
  );

  // Children call msg() during their first render, before any effect of this provider could run.
  registerIntl(intl);

  useEffect(() => {
    registerIntl(intl);
    return () => unregisterIntl(intl);
  }, [intl]);

  return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
}
